export default __webpack_public_path__ + "img/b71055fecb777f220aa9ef1b2a1c80e2.svg";